const previewStatusMap = {
  approved: 'approved',
  change_request: 'change_request',
  waiting_for_feedback: 'waiting_for_feedback',
}
export default previewStatusMap
